"use client";

import React from "react";

export function AnimatedLogo() {
  return (
    <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center">
      <img src="/animated-logo.svg" alt="Animated Logo" className="w-full h-auto" />
    </div>
  );
}
